<script lang="ts">
	import { track } from '$lib/services/tracking/googleAnalytics';
	import { getPoiListTrackingEvent } from '$lib/services/tracking/googleAnalytics/pois';
	import { type SummaryPoiData } from '../types';
	import GasStationPoiSummary from './gasStation/GasStationPoiSummary.svelte';
	import ParkingPoiSummary from './parking/ParkingPoiSummary.svelte';

	export let poiData: SummaryPoiData;
</script>

{#if poiData.__typename === 'ParkingPOI'}
	<ParkingPoiSummary
		name={poiData.name}
		address={poiData.splittedAddress}
		bookUrl={poiData.redirectUrl}
		on:bookClick={() => track(getPoiListTrackingEvent(poiData, 'poimap_book'))}
		on:addClick
	/>
{:else if poiData.__typename === 'ServiceGasStationPOI'}
	<GasStationPoiSummary
		name={poiData.name}
		fuelPrices={poiData.fuels?.prices}
		lastUpdated={poiData.fuels?.lastUpdatedAt ? new Date(poiData.fuels?.lastUpdatedAt) : undefined}
		on:addClick
	/>
{/if}
